import {
  createSchemaConfig,
  buildTimeIntervalDimensionsConfig,
  buildTimeIntervalDimensionsGrouping,
} from '../helpers/schema.helpers'
import {
  InsightsFormatterType,
  InsightsGroupByTypes,
  InsightsMetricDesiredDirection,
} from '../types/schema.types'
import { insightsPortalRrcCodeDimensionAccessControl } from '../../access-control/insightsPortalAccess.configuration'
import { Metrics, Dimensions } from './insightsPortalOrderItems.types'

export { Metrics, Dimensions }

export const schemaConfig = createSchemaConfig({
  metrics: Metrics,
  dimensions: Dimensions,
  metricsConfig: {
    [Metrics.COUNT_ORDER]: {
      formatter: InsightsFormatterType.Integer,
      label: 'insightsPortalDomain.performanceDashboard.metrics.COUNT_ORDER',
      tooltip: 'insightsPortalDomain.basketDashboard.tooltips.COUNT_ORDER',
    },
    [Metrics.SUM_GMV_USD]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.performanceDashboard.metrics.SUM_GMV_USD',
      tooltip: 'insightsPortalDomain.performanceDashboard.tooltips.SUM_GMV_USD',
    },
    [Metrics.SUM_GMV]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.performanceDashboard.metrics.SUM_GMV',
    },
    [Metrics.SUM_ERV]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.performanceDashboard.metrics.SUM_ERV',
    },
    [Metrics.AVG_ITEM_FOUND]: {
      formatter: InsightsFormatterType.Percentage,
      label: 'insightsPortalDomain.outOfStockDashboard.metrics.AVG_ITEM_FOUND',
      tooltip: 'insightsPortalDomain.outOfStockDashboard.tooltips.AVG_ITEM_FOUND',
    },
    [Metrics.LOST_GMV]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.outOfStockDashboard.metrics.LOST_GMV',
      tooltip: 'insightsPortalDomain.outOfStockDashboard.tooltips.LOST_GMV',
      desiredDirection: InsightsMetricDesiredDirection.NEGATIVE,
    },
    [Metrics.AVG_ITEM_FILLED]: {
      formatter: InsightsFormatterType.Percentage,
      label: 'insightsPortalDomain.outOfStockDashboard.metrics.AVG_ITEM_FILLED',
      tooltip: 'insightsPortalDomain.outOfStockDashboard.tooltips.AVG_ITEM_FILLED',
    },
    [Metrics.AVG_LOST_GMV_PER_STORE]: {
      formatter: InsightsFormatterType.Currency,
      label:
        'insightsPortalDomain.outOfStockDashboard.geographyPerformance.table.header.avgLostGmv',
    },
    [Metrics.AVG_ITEM_REPLACED]: {
      formatter: InsightsFormatterType.Percentage,
      label: 'insightsPortalDomain.outOfStockTable.replacementRate',
    },
    [Metrics.AVG_BASKET]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.orderItems.metrics.AVG_BASKET',
      tooltip: 'insightsPortalDomain.basketDashboard.tooltips.AVG_BASKET',
    },
    [Metrics.AVG_ORDERED_ITEM]: {
      formatter: InsightsFormatterType.Decimal,
      label: 'insightsPortalDomain.orderItems.metrics.AVG_ORDERED_ITEM',
      tooltip: 'insightsPortalDomain.basketDashboard.tooltips.AVG_ORDERED_ITEM',
    },
    [Metrics.AVG_ITEM_FILLED_PRICE]: {
      formatter: InsightsFormatterType.Currency,
      label: 'insightsPortalDomain.orderItems.metrics.AVG_ITEM_FILLED_PRICE',
      tooltip: 'insightsPortalDomain.basketDashboard.tooltips.AVG_ITEM_FILLED_PRICE',
    },
  },
  dimensionsConfig: {
    [Dimensions.INSIGHTS_PORTAL_ORDER_SOURCE]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.collections.filters.orderSource',
    },
    [Dimensions.PLATFORM]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.placements.filters.platform',
      private: true,
    },
    [Dimensions.INSIGHTS_PORTAL_REPORTING_PLATFORM]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.placements.filters.platform',
      private: true,
    },
    [Dimensions.PRODUCT_CATEGORY_ID]: {
      type: InsightsGroupByTypes.Info,
      private: true,
    },
    [Dimensions.PICKUP]: {
      type: InsightsGroupByTypes.Program,
      private: true,
      label: 'insightsPortalDomain.filters.fulfillmentType.label',
    },
    [Dimensions.FULFILLMENT_TYPE]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.fulfillmentType.label',
    },
    [Dimensions.WAREHOUSE]: {
      type: InsightsGroupByTypes.Info,
      label: 'insightsPortalDomain.filters.retailers.label',
    },
    [Dimensions.ALCOHOL]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.filters.alcohol.orders.label',
    },
    [Dimensions.EXPRESS]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.filters.express.orders.label',
    },
    [Dimensions.LOYALTY]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.filters.loyalty.label',
    },
    [Dimensions.RETAILER_PRODUCT]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.collectionProducts.groupBys.productName',
    },
    [Dimensions.EBT_ITEM]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      private: true,
      label: 'insightsPortalDomain.filters.ebt.label',
    },
    [Dimensions.FIRST_ORDER]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.performanceDashboard.metrics.COUNT_FIRST_ORDER',
    },
    [Dimensions.VIRTUAL_WAREHOUSE]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.filters.convenience.label',
    },
    [Dimensions.WAREHOUSE_LOCATION]: {
      type: InsightsGroupByTypes.Info,
      label:
        'insightsPortalDomain.AggWarehouseLocationCampaignPerformance.metrics.WAREHOUSE_LOCATION',
    },
    [Dimensions.WAREHOUSE_LOCATION_CODE]: {
      type: InsightsGroupByTypes.Info,
      magnitude: 5,
      label: 'insightsPortalDomain.campaigns.groupBys.WAREHOUSE_LOCATION_CODE',
    },
    [Dimensions.WAREHOUSE_LOCATION_STATE]: {
      type: InsightsGroupByTypes.Info,
      label:
        'insightsPortalDomain.AggWarehouseLocationCampaignPerformance.metrics.WAREHOUSE_LOCATION_STATE',
    },
    [Dimensions.PARTNER_GEO_DIVISION]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.partnerDivision.label',
    },
    [Dimensions.ORDER_CURRENCY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.orderCurrency.label',
    },
    [Dimensions.PRODUCT_UPC_CODE]: {
      type: InsightsGroupByTypes.Info,
      label: 'insightsPortalDomain.collections.groupBys.productUpcCode',
    },
    [Dimensions.PRODUCT_RRC_CODE]: {
      type: InsightsGroupByTypes.Info,
      private: insightsPortalRrcCodeDimensionAccessControl,
      label: 'insightsPortalDomain.collections.groupBys.productRrcCode',
    },
    [Dimensions.REGION]: {
      type: InsightsGroupByTypes.Info,
      label: 'insightsPortalDomain.controls.groupBy.region',
    },
    [Dimensions.EBT_ORDER]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.filters.ebt.label',
    },
    [Dimensions.L1_CATEGORY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.productCategories.L1Category',
    },
    [Dimensions.L2_CATEGORY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.productCategories.L2Category',
    },
    [Dimensions.L3_CATEGORY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.productCategories.L3Category',
    },
    [Dimensions.L4_CATEGORY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.productCategories.L4Category',
    },
    [Dimensions.L5_CATEGORY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.productCategories.L5Category',
    },
    [Dimensions.L6_CATEGORY]: {
      type: InsightsGroupByTypes.Program,
      label: 'insightsPortalDomain.filters.productCategories.L6Category',
    },
    [Dimensions.RX_ORDER]: {
      type: InsightsGroupByTypes.Program,
      formatter: InsightsFormatterType.YesOrNo,
      label: 'insightsPortalDomain.filters.rx.orders.label',
    },
    [Dimensions.WAREHOUSE_LOCATION_GROUP]: {
      type: InsightsGroupByTypes.Info,
      label: 'insightsPortalDomain.filters.warehouseLocationGroup.label',
    },
    [Dimensions.DELIVERY_TYPE]: {
      type: InsightsGroupByTypes.Program,
      magnitude: 1,
      label: 'insightsPortalDomain.filters.deliveryType.label',
    },
    ...buildTimeIntervalDimensionsConfig,
  },
  dimensionGroupings: [
    buildTimeIntervalDimensionsGrouping,
    {
      label: 'insightsPortalDomain.filters.stores',
      dimensions: [
        Dimensions.WAREHOUSE,
        Dimensions.WAREHOUSE_LOCATION_STATE,
        Dimensions.REGION,
        Dimensions.WAREHOUSE_LOCATION_GROUP,
        Dimensions.WAREHOUSE_LOCATION,
        Dimensions.WAREHOUSE_LOCATION_CODE,
        Dimensions.PARTNER_GEO_DIVISION,
      ],
    },
    {
      label: 'insightsPortalDomain.filters.orders',
      dimensions: [
        Dimensions.INSIGHTS_PORTAL_ORDER_SOURCE,
        Dimensions.FULFILLMENT_TYPE,
        Dimensions.ALCOHOL,
        Dimensions.VIRTUAL_WAREHOUSE,
        Dimensions.EXPRESS,
        Dimensions.LOYALTY,
        Dimensions.EBT_ORDER,
        Dimensions.RX_ORDER,
        Dimensions.FIRST_ORDER,
        Dimensions.ORDER_CURRENCY,
        Dimensions.DELIVERY_TYPE,
      ],
    },
    {
      label: 'insightsPortalDomain.filters.groups.categories',
      dimensions: [
        Dimensions.L1_CATEGORY,
        Dimensions.L2_CATEGORY,
        Dimensions.L3_CATEGORY,
        Dimensions.L4_CATEGORY,
        Dimensions.L5_CATEGORY,
        Dimensions.L6_CATEGORY,
      ],
    },
  ],
})
